<template>
    <v-layout row wrap justify-center align-center>
        <v-flex xs12 sm10 md8 lg5 class="mx-3 mb-3">
            <v-card>
                <v-card-text>
                    <v-text-field label="Advertise name" hide-details></v-text-field>
                    <v-select label="Status" hide-details :items="status"></v-select>
                    <input style="display:none;" type="file" ref="LogoInput" accept="image/*">
                    <v-btn class="my-3" @click="$refs.LogoInput.click()">choose file</v-btn>
                        <div class="style-title-detail">
                        File name :
                        <span class="style-data-detail">{{img_url}}</span>
                    </div>
                    <v-img dark aspect-ratio="1" :src="img_url"></v-img>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" class="black--text">submit</v-btn>
                <v-spacer/>
            </v-card-actions>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    data() {
        return {
            img_url:require('@/assets/bg-yellow.jpg'),
            status:['Active','Inactive']
        }
    }
}
</script>
<style scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}
</style>


